import React from 'react';
import { ButtonProps, ButtonBase } from '@src/shared/ui/buttons';
import { colors } from '@src/config/theme/tokens';

export const TextButton: React.FC<ButtonProps> = ({
  id,
  children,
  onClick,
  className,
  disabled,
}) => {
  const styled = disabled
    ? {}
    : {
        textTransform: 'none',
        '&.MuiButtonBase-root:hover': {
          bgcolor: 'transparent',
          color: colors.primary40,
        },
      };
  return (
    <ButtonBase
      id={id}
      onClick={onClick}
      className={`text-orange-500 hover:text-orange-600 text-base ${className}`}
      sx={styled}
      disableTouchRipple={true}
      variant='text'
      disabled={disabled}
    >
      {children}
    </ButtonBase>
  );
};
